export default __webpack_public_path__ + "static/media/vi.31e04ebd.svg";